import { IconProps } from './IconProps';
export function NotesIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2673_90421)">
                <path
                    d="M9.00781 20.4941H1.50781C1.2426 20.4941 0.988242 20.3888 0.800706 20.2012C0.613169 20.0137 0.507813 19.7594 0.507812 19.4941V3.49414C0.507812 3.22892 0.613169 2.97457 0.800706 2.78703C0.988242 2.5995 1.2426 2.49414 1.50781 2.49414H15.5078C15.773 2.49414 16.0274 2.5995 16.2149 2.78703C16.4025 2.97457 16.5078 3.22892 16.5078 3.49414V10.9941"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.50781 4.49414V0.494141"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.50781 4.49414V0.494141"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.5078 4.49414V0.494141"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22.8878 15.1136L15.2578 22.7436L11.5078 23.4936L12.2578 19.7436L19.8878 12.1136C20.2844 11.717 20.8224 11.4941 21.3833 11.4941C21.9442 11.4941 22.4822 11.717 22.8788 12.1136L22.8878 12.1216C23.2845 12.5184 23.5073 13.0565 23.5073 13.6176C23.5073 14.1787 23.2845 14.7168 22.8878 15.1136Z"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2673_90421">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
